export default __webpack_public_path__ + "static/media/building.4720962d.png";